<template>
  <div v-loading="!settingsLoaded">
    <div v-if="settingsLoaded">
      <div>{{ edeliveryScheduleInfo }}</div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ba-edelivery-schedule-info',
  watch: {
    manualEdeliveryOnly: {
      handler (newVal) {
        this.$emit('onManualEdeliveryOnlyUpdate', newVal)
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('settings', ['getSetting']),
    settingsLoaded () {
      return this.getSetting('e_delivery.new_flow_send_documents_on_edeliverable_import_times') !== null
    },
    manualEdeliveryOnly () {
      if (!this.settingsLoaded) {
        return null
      }
      return this.getSetting('e_delivery.new_flow_send_documents_on_edeliverable_import_times') !== 'true'
    },
    edeliveryScheduleInfo () {
      let rawImportSchedule = this.getSetting('e_delivery.new_flow_scheduled_import_times')

      if (this.manualEdeliveryOnly) {
        return `E-Delivery processing must be approved via the button below. Pre-Imports occurs overnight and at ${rawImportSchedule} UTC`
      } else {
        return `E-Delivery processing automatically occurs at ${rawImportSchedule} UTC`
      }
    },
  },
}
</script>
